'use strict';

var _jockey = require('@souche-f2e/jockey');

var _jockey2 = _interopRequireDefault(_jockey);

var _common = require('./lib/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 其他设置
module.exports = {
	// 打开地图
	openMap: function openMap(addr, cb) {
		_jockey2.default.send('MapBridge', {
			keyword: addr
		}, function (res) {
			cb && cb(res);
		});
	},
	/**
  * @desc 调用系统的提示框
  * @param {Object} params 页面tag
  *      title    {String}    标题            默认值：'提示框'
  *      message  {String}    提示            默认值：''
  *      cancel   {String}    取消按钮的文案   默认值：'取消'
  *      other    {String}    去顶按钮的文案   默认值：'确定'
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  action	点击按钮的位置	int	0-取消 1-确定
  */
	confirm: function confirm(params) {
		var data = {
			title: '提示框',
			message: '',
			cancel: '取消',
			other: '确定'
		};
		data = _common2.default.extend(data, params);
		return new Promise(function (resolve) {
			_jockey2.default.send("AlertBridge", data, function (res) {
				resolve(res.action);
			});
		});
	},

	/**
  * @desc  下载H5包
  * @param {String}   url H5下载地址
  * @param {Boolean}  网络状态下是否提示升级   ture 提示  false 不提示
  * @param {Function} 回调函数
  *      回调数据:  result	结果	string	true成功 false失败
  */
	downLoadH5Pack: function downLoadH5Pack(url, is2GConfirm, cb) {
		return new Promise(function (resolve) {
			_jockey2.default.send("DownLoadH5Handler", {
				url: url,
				is2GConfirm: is2GConfirm ? 1 : 0
			}, function (res) {
				resolve(res.result);
			});
		});
	},

	/**
  * @desc  下载H5包(大风车)
  */
	downLoadH5Pack2: function downLoadH5Pack2(params) {
		_jockey2.default.send("loadH5", params);
	},

	/**
  * @desc h5调起微信支付  (所需数据都是第三方提供，具体生成规则请邮件服务器负责人沈凯和客户端负责人陈轩石)
  * @param {Object} params 微信支付所需数据
  *      prepayid    {String}    订单ID             必传
  *      nonce_str   {String}    随机串             必传
  *      timestamp   {String}    时间挫             必传
  *      package     {String}    财付通的数据和签名  必传
  *      sign        {String}    微信签名           必传
  * @param {Function} cb 点击之后页面带的回调
  *      回调数据:  result	结果	int	0-成功 1-失败 2-取消 3-不支持
  */
	wechatPay: function wechatPay(params, cb) {
		return new Promise(function (resolve) {
			_jockey2.default.send("WechatPaymentBridge", params, function (res) {
				resolve(res.resut);
			});
		});
	},

	/**
  * @desc h5调起人脸识别  (具体生成规则请邮件前端负责人王琦和客户端负责人杨耀)
  * @param {Object} params 人脸识别所需数据
  *      name       {String}    姓名       必传
  *      idCard     {String}    身份证号   必传
  *      schemaURL  {String}    认证url	必传
  */
	facePerception: function facePerception(params) {
		return new Promise(function (resolve) {
			_jockey2.default.send("FacePerceptionBridge", params, function (res) {
				var arr = res.recognizeResult.split('&');
				resolve({
					params: arr[0].split('=')[1],
					sign: arr[1].split('=')[1]
				});
			});
		});
	},

	/**
  * @desc  车系选择
  * @param {Number}   level   1-只有品牌 2-品牌车系 3-品牌车系车型   必传
  * @param {Boolean}  hot      回调函数             可选
  *       回调数据：是否成功
  * @note  Android只在level=3的时候才会显示热门品牌，当level=1或2时此项可不填或者统一置为false
  *       回调数据  brand series model
  */
	carSelect: function carSelect(level, hot) {
		hot = hot ? 1 : 0;
		return new Promise(function (resolve) {
			_jockey2.default.send('CarSelectorBridge', {
				level: level,
				hot: hot
			}, function (data) {
				resolve(data.selected[0]);
			});
		});
	},

	/**
  * @desc  操作和处理统一用协议的方式去打开
  * @param {String}   agreeemnt   协议名称   必传
  * @param {Function} cb          回调函数   可选
  *       回调数据  根据协议跟app协商
  */
	agreeement: function agreeement(agreeemnt, cb) {
		_jockey2.default.send("ModulorHandle", {
			protocol: agreeemnt
		}, function (data) {
			cb && cb(data);
		});
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/~/@souche-f2e/tower/lib/other.js
// module id = 270
// module chunks = 4